import moment from 'moment/moment';
import * as XLSX from 'xlsx';

export const getCalendarExportFileName = (startDate, endDate, extension) => {
  const baseName = startDate.startOf('day').isSame(endDate.startOf('day'))
    ? `Skinboost_Calendario_${startDate.format('DD-MM-YYYY')}`
    : `Skinboost_Calendario_${startDate.format('DD-MM-YYYY')}_${endDate.format('DD-MM-YYYY')}`;

  return `${baseName}.${extension}`;
};

const mapAppointmentToRow = (appointment) => {
  if (appointment?.status === 'blocked') {
    return {
      Paziente: 'Blocco',
      Età: '',
      'Data di nascita': '',
      Telefono: '',
      Email: '',
      Ora: moment(`${appointment?.date} ${appointment?.start_hour}`).format('HH:mm'),
      Data: moment(`${appointment?.date} ${appointment?.start_hour}`).format('DD/MM/YYYY'),
      Ufficio: appointment?.calendar?.office?.name || '',
      Medico: `${appointment?.calendar?.doctor?.name || ''} ${appointment?.calendar?.doctor?.surname || ''}`.trim(),
      Trattamento: '',
      'Prezzo (€)': '',
      'Durata (min)': moment(`${appointment?.date} ${appointment?.end_hour}`).diff(
        moment(`${appointment?.date} ${appointment?.start_hour}`),
        'minutes'
      ),
      Note: appointment?.note || ''
    };
  }

  const patientName = appointment?.patient?.name
    ? `${appointment?.patient?.name} ${appointment?.patient?.surname}`
    : appointment?.patient_alias || '';
  const age = appointment?.patient?.birthday_date
    ? moment().diff(moment(appointment?.patient?.birthday_date), 'years')
    : appointment?.patient?.age;
  const birthday = appointment?.patient?.birthday_date
    ? moment(appointment?.patient?.birthday_date).format('DD/MM/YYYY')
    : '';
  const phone = appointment?.patient?.phone
    ? `${appointment?.patient?.phone_country?.dial_code || ''} ${appointment?.patient?.phone}`.trim()
    : appointment?.patient_phone || '';
  const email = appointment?.patient?.email || appointment?.patient_email || '';

  return {
    Paziente: patientName,
    Età: age ?? '',
    'Data di nascita': birthday,
    Telefono: phone,
    Email: email,
    Ora: moment(`${appointment?.date} ${appointment?.start_hour}`).format('HH:mm'),
    Data: moment(`${appointment?.date} ${appointment?.start_hour}`).format('DD/MM/YYYY'),
    Ufficio: appointment?.calendar?.office?.name || '',
    Medico: `${appointment?.calendar?.doctor?.name || ''} ${appointment?.calendar?.doctor?.surname || ''}`.trim(),
    Trattamento: appointment?.treatment?.name || '',
    'Prezzo (€)': appointment?.treatment?.doctor_treatment?.price ?? '',
    'Durata (min)': moment(`${appointment?.date} ${appointment?.end_hour}`).diff(
      moment(`${appointment?.date} ${appointment?.start_hour}`),
      'minutes'
    ),
    Note: appointment?.note || ''
  };
};

export const exportCalendarAppointmentsToExcel = (appointments, { startDate, endDate }) => {
  const rows = appointments.map(mapAppointmentToRow);
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Appuntamenti');
  XLSX.writeFile(workbook, getCalendarExportFileName(startDate, endDate, 'xlsx'));
};
